import * as React from "react";
import { Moment } from "moment";
import { Table } from "semantic-ui-react";

import { TableDetail } from "./TableDetail";

interface Props {
    reviewDate: Moment;
    consultationDate: Moment;
}

const ConsultationDetails: React.FunctionComponent<Props> = (props) => {

    const dateOfAssessment = props.consultationDate.isValid() ? props.consultationDate.format("Do MMMM YYYY") : "";
    const dateResultsViewed = props.reviewDate.isValid() ? props.reviewDate.format("Do MMMM YYYY") : "";

    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>
                        Assessment Details
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <TableDetail name="Date of Assessment" value={dateOfAssessment} />
                <TableDetail name="Date Results Viewed" value={dateResultsViewed} />
            </Table.Body>
        </Table>
    );
};

export { ConsultationDetails };
